// extracted by mini-css-extract-plugin
export var printerCard = "_i0-1";
export var printerCardConfigured = "_i0-2";
export var printerCardError = "_i0-3";
export var printerCardsContainer = "_i0-0";
export var printerIcon = "_i0-8";
export var printerIconConfigured = "_i0-5";
export var printerIconContainer = "_i0-4";
export var printerIconError = "_i0-6";
export var printerIconUnconfigured = "_i0-7";
export var workstationsTableCard = "_i0-9";